import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import { useVault } from '../context/VaultContext';

export function useLibraryList(query: Record<string, any> = {}) {
  const { activeVaultId } = useVault();
  const queryWithVault = activeVaultId ? { ...query, vaultId: activeVaultId } : query;

  return useQuery({
    queryKey: ['library', queryWithVault],
    queryFn: () => apiClient.listLibraryFiles(queryWithVault),
  });
}

export function useItemFiles(itemId: string) {
  return useQuery({
    queryKey: ['itemFiles', itemId],
    queryFn: () => apiClient.getItemFiles(itemId),
    enabled: !!itemId,
  });
}

export function useUploadLibraryFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => apiClient.uploadLibraryFile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['library'] });
      queryClient.invalidateQueries({ queryKey: ['itemFiles'] });
    },
  });
}

export function useDeleteLibraryFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (fileId: string) => apiClient.deleteLibraryFile(fileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['library'] });
      queryClient.invalidateQueries({ queryKey: ['itemFiles'] });
    },
  });
}
